import { Controller } from "@hotwired/stimulus"

// Renders a 12h AM/PM time picker using three selects (hour, minute, AM/PM)
// and syncs to a hidden input that carries the form field's actual 24h HH:MM
// value. Used instead of native <input type="time"> so that Indian-locale
// Chromium does not force 24h display.
export default class extends Controller {
  static targets = ["input", "hour", "minute", "period"]
  static values = { allowBlank: Boolean }

  sync() {
    const hStr = this.hourTarget.value
    if (hStr === "" && this.allowBlankValue) {
      this.inputTarget.value = ""
      return
    }
    let h = parseInt(hStr, 10) || 12
    const period = this.periodTarget.value
    if (period === "PM" && h !== 12) h += 12
    if (period === "AM" && h === 12) h = 0
    const m = parseInt(this.minuteTarget.value, 10) || 0
    this.inputTarget.value = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`
  }
}
